(function(module) {
    'use strict';

    const timezones = moment.tz.names();
    const TIMEZONES = timezones.map((timezone) => {
        return {
            value: timezone,
            name: timezone,
        };
    });
    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'moment-timezone-select',
            template: `
                <div class="moment-timezone-select" >
                    <md-input-container class="time-zone-autocomplete">
                        <md-autocomplete
                            placeholder="Type your Time Zone / City"
                            md-selected-item="selectedTimeZone"
                            md-items="zone in filtered(searchText)"
                            md-selected-item-change="onTimeZoneChange(zone)"
                            md-search-text="searchText" 
                            md-item-text="zone.name"
                            md-min-length="1"
                            md-select-on-match="true"
                            md-mode="virtual"
                            required
                        >
                            <md-item-template>
                                <span md-highlight-text="searchText" md-highlight-flags="i">{{ zone.name }}</span>
                            </md-item-template>
                            <md-not-found>
                                No matches found.
                            </md-not-found>
                        </md-autocomplete>
                    </md-input-container>
                </div>
            `,
            controller: ['$scope', '$q', ($scope, $q) => {
                $scope.to.options = TIMEZONES;
                const timeZone = $scope.model.timezone ? $scope.model.timezone : 'Europe/London';
                $scope.selectedTimeZone = _.find(TIMEZONES, { value: timeZone });

                $scope.filtered = (query) => {
                    if (!query) return $q.resolve(TIMEZONES);
                    const regexp = new RegExp(`${query}`, 'i');
                    return $q.resolve(TIMEZONES.filter(zone => regexp.test(zone.name)));
                };

                $scope.onTimeZoneChange = (zone) => {
                    const ZONE_TO_SET = zone ? zone.value : null;
                    _.set($scope, `model.${$scope.options.key}`, ZONE_TO_SET);
                };
            }],
        });
    }]);
})(angular.module('rocket.components'));

